<template>
  <div>
    <div class="table-container">
      <table class="table is-narrow user-details">
        <tbody>
          <tr>
            <th class="is-narrow">
              <span class="is-pulled-right">Pro Subscription Expires</span>
            </th>
            <td>
              <a @click="changeProExpirationDateClicked">
                <span>
                  {{ user.subscriptionExpirationDate || 'Set' }}
                  <i class="icon-edit-2"></i>
                </span>

                <!-- <span v-if="!user.subscriptionExpirationDate">
                  <i class="icon-edit-2"></i>
                </span> -->
              </a>
            </td>
          </tr>
          <tr>
            <th class="is-narrow">
              <span class="is-pulled-right">Android Subscription Order Id</span>
            </th>
            <td>
              <span>{{ user.androidSubscriptionOrderId }}</span>
            </td>
          </tr>
          <tr>
            <th class="is-narrow">
              <span class="is-pulled-right">Android Subscription Product Id</span>
            </th>
            <td>
              <span>{{ user.androidSubscriptionProductId }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modals -->
    <UserChangeProExpirationDateModal
      v-if="showChangeProExpirationDateModal"
      :userStorePath="userStorePath"
      @cancelled="closeChangeProExpirationDateModal"
      @succeeded="closeChangeProExpirationDateModal"
    />
  </div>
</template>

<script>
import UserChangeProExpirationDateModal from "./UserChangeProExpirationDateModal";

import {
  GET_USER
} from "./userStore";

export default {
  name: "UserProTab",

  components: { UserChangeProExpirationDateModal },

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showChangeProExpirationDateModal: false
    };
  },

  computed: {
    user() {
      const getUser = `${this.userStorePath}/${GET_USER}`;
      return this.$store.getters[getUser];
    }
  },

  methods: {
    changeProExpirationDateClicked() {
      this.showChangeProExpirationDateModal = true;
    },

    closeChangeProExpirationDateModal() {
      this.showChangeProExpirationDateModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  th {
    padding-right: 0 !important;
    border-bottom: 0;

    span {
      font-weight: normal;
    }
  }

  td {
    border-bottom: 0;

    span {
      font-weight: bold;
      white-space: nowrap;
    }
  }
}
</style>
